import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Estado } from 'src/app/model/estado.model';
import { SolicitacaoCancelamentoGarantia } from 'src/app/model/solicitacao-cancelamento-garantia.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoCancelamentoGarantiaService } from 'src/app/shared/services/solicitacao-cancelamento-garantia.service';



@Component({
    selector: 'app-cancelamento-pesquisa',
    templateUrl: './cancelamento-pesquisa.component.html',
    styleUrls: ['./cancelamento-pesquisa.component.scss'],
    standalone: false
})
export class CancelamentoPesquisaComponent implements OnInit {

  private pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  private podeEscolherAgente = false;  // usado no html
  private podeEnviarSolicitacaoCancelamento = false; // usado no html
  private ehAgenteFinanceiro = false;
  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private estados: Estado[] = [];
  private cnpjUsuario: string;
  private solicitacoesCancelamento: SolicitacaoCancelamentoGarantia[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<SolicitacaoCancelamentoGarantia>;
  private opcoesPaginacao: number[];
  private parametrosPesquisa: any = {};
  private totalObjetosRetornados: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private cancelamentoService: SolicitacaoCancelamentoGarantiaService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private fileUtils: FileUtilsService) {

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.estados = this.activatedRoute.snapshot.data['estados'];
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false, true)
  }
  ngOnInit() {
    this.valoresPesquisaForm = undefined;
    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario ? usuario.cnpj : null;
    });

    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.pesquisaForm = this.formBuilder.group({
      agenteFinanceiro: [null],
      idSolicitacaoCancelamento: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(1), Validators.maxLength(36)]],
      estado: [null],
      idExternoOperacao: [null, [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      sistema: [null],
      contrato: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      dataEnvioInicio: [null],
      dataEnvioFim: [null]
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviarSolicitacaoCancelamento = resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];

      this.construirFormulario();
    });
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaSolicitacaoCancelamentoForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    let agenteDefault: AgenteFinanceiro;
    if (this.podeEscolherAgente) {
      agenteDefault = this.valoresPesquisaForm.agenteFinanceiro ?
        this.agentesFinanceiros.filter(agente => agente.id === this.valoresPesquisaForm.agenteFinanceiro.id)[0]
        : null;
    } else {
      agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
      this.pesquisaForm.get('agenteFinanceiro').disable();
    };

    this.pesquisaForm.patchValue({
      agenteFinanceiro: agenteDefault,
      nomeJanela: this.valoresPesquisaForm.nomeJanela ? new Date(this.valoresPesquisaForm.nomeJanela) : null,
      estado: this.valoresPesquisaForm.estado ? this.estados.filter(i => i.id === this.valoresPesquisaForm.estado.id)[0] : null,
      sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : null,
      idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null,
      contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato : null,
      dataEnvioInicio: this.valoresPesquisaForm.dataEnvioInicio ? this.valoresPesquisaForm.dataEnvioInicio : null,
      dataEnvioFim: this.valoresPesquisaForm.dataEnvioFim ? this.valoresPesquisaForm.dataEnvioFim : null
    });

    this.controlaCamposDesabilitados(this.valoresPesquisaForm);

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.controlaCamposDesabilitados(novosValores);
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaSolicitacaoCancelamentoForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  private controlaCamposDesabilitados(novosValores) {
    if (novosValores.sistema == 'CL') {
      if (!this.pesquisaForm.get('contrato').disabled) {
        if (this.pesquisaForm.get('contrato').value != '') {
          this.pesquisaForm.get('contrato').setValue('');
        }
        this.pesquisaForm.get('contrato').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('contrato').disabled) {
        this.pesquisaForm.get('contrato').enable();
      }
    }

    if (novosValores.sistema == '89' || novosValores.sistema == '15') {
      if (!this.pesquisaForm.get('idExternoOperacao').disabled) {
        if (this.pesquisaForm.get('idExternoOperacao').value != '') {
          this.pesquisaForm.get('idExternoOperacao').setValue('');
        }
        this.pesquisaForm.get('idExternoOperacao').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('idExternoOperacao').disabled) {
        this.pesquisaForm.get('idExternoOperacao').enable();
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoCancelamentoGarantia>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia, voltarPagina1) {
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (agenteFinanceiro) {
      params.cnpjAgenteFinanceiro = agenteFinanceiro.cnpj;
    }

    const idSolicitacaoCancelamento = this.pesquisaForm.get('idSolicitacaoCancelamento').value;
    if (idSolicitacaoCancelamento) {
      params.idSolicitacaoCancelamento = idSolicitacaoCancelamento;
    }

    const sistema = this.pesquisaForm.get('sistema').value;
    if (sistema) {
      params.sistema = sistema;
    }

    const idExternoOperacao = this.pesquisaForm.get('idExternoOperacao').value;
    if (idExternoOperacao && idExternoOperacao.trim()) {
      params.idExternoOperacao = idExternoOperacao.trim();
    }

    const dataEnvioInicio = this.pesquisaForm.get('dataEnvioInicio').value;
    if (dataEnvioInicio) {
      params.dataEnvioInicio = this.datePipe.transform(dataEnvioInicio, 'yyyyMMdd');
    }

    const dataEnvioFim = this.pesquisaForm.get('dataEnvioFim').value;
    if (dataEnvioFim) {
      params.dataEnvioFim = this.datePipe.transform(dataEnvioFim, 'yyyyMMdd');
    }

    const contrato = this.pesquisaForm.get('contrato').value;
    if (contrato && contrato.trim()) {
      params.contrato = contrato.trim();
    }

    const estado: Estado = this.pesquisaForm.get('estado').value;
    if (estado) {
      params.idEstado = Number(estado.id);
    }

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));


    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.solicitacoesCancelamento, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }
    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.cancelamentoService.getSolicitacoesCancelamento(params)
      .subscribe(response => {
        this.solicitacoesCancelamento = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.solicitacoesCancelamento, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {
    this.pesquisado = false;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.reset({ agenteFinanceiro: this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0] });
    } else {
      this.pesquisaForm.reset();
    }
    this.solicitacoesCancelamento = [];
  }

  public exportarSolicitacoesCancelamento(): string {

    let todasSolicitacoesCancelamento;
    let csv = ` ID; AGENTE FINANCEIRO; ID. EXT. OPERAÇÃO; SIST./CONTRATO; DATA ENVIO; ESTADO; VALOR DA MULTA (%)\n`;

    this.loadingService.bloqueiaTela();
    this.cancelamentoService.getSolicitacoesCancelamento(this.parametrosPesquisa).subscribe(response => {
      let tmp: string = "";

      (todasSolicitacoesCancelamento = response ? response.resultados : undefined) &&
        todasSolicitacoesCancelamento.forEach(solicitacoes => {
          tmp += `${solicitacoes.id};${Utils.nomeAgentePorCNPJ(solicitacoes.cnpjAgenteFinanceiro, this.agentesFinanceiros)};${this.normalizaZerosAEsquerda(solicitacoes.idOperacaoExterno)};${solicitacoes.contratoRepasse ? solicitacoes.sistemaRepasse + '/' + solicitacoes.contratoRepasse : ''};${this.datePipe.transform(solicitacoes.dataEnvio, 'dd/MM/yyyy HH:mm')};${solicitacoes.estado.nomeEstado};${solicitacoes.valorPercentualMulta ? Number(solicitacoes.valorPercentualMulta).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '0'}\n`;
        });
      this.loadingService.liberaTela();
      csv += tmp;
      this.exportar('SOLICITACOES_CANCELAMENTO.csv', csv);
    });

    return csv;
  }

  private exportar(nomeArquivo: string, conteudoCsv: any): void {
    this.fileUtils.exportarArquivo(nomeArquivo, "\ufeff" + conteudoCsv, FileUtilsService.TEXT_CSV);
  }

  private normalizaZerosAEsquerda(linha: string) {
    return Utils.formataZerosAEsquerda(linha);
  }

}
